import React from "react";
import Navigation from "../Navbar/Navbar";
import Footer from '../Footer/footer'

const Header = () => {
  return (
    <header>
      <Navigation />
      

    </header>
  );
};

export default Header;
